import { createSlice } from "@reduxjs/toolkit";
import {
  SSE_REQUEST_STATUS_FAILED,
  SSE_REQUEST_STATUS_PENDING,
  SSE_REQUEST_STATUS_SUCCESS
} from "../../../constants/sseEvents.js";

const initialState = {
  userUUID: null,
  sseRequestIsLoading: false,
  sseRequestError: null,
  sseRequestStatus: null,
  sessionMessage: ''
};

export const sseSession = createSlice({
  name: "sseSession",
  initialState,
  reducers: {
    updateUserUUID(state, action) {
      state.userUUID = action.payload;
    },
    sessionRequestStart(state) {
      state.sseRequestStatus = SSE_REQUEST_STATUS_PENDING;
      state.sseRequestIsLoading = true;
      state.sseRequestError = null;
    },
    sessionRequestSuccess(state) {
      state.sseRequestStatus = SSE_REQUEST_STATUS_SUCCESS;
      state.sseRequestIsLoading = false;
    },
    sessionRequestFailed(state, action) {
      state.sseRequestStatus = SSE_REQUEST_STATUS_FAILED;
      state.sseRequestError = action.payload;
      state.sseRequestIsLoading = false;
    },
    setSessionMessage(state, action) {
      state.sessionMessage = action.payload
    }
  }
});

export const {
  updateUserUUID,
  sessionRequestStart,
  sessionRequestSuccess,
  sessionRequestFailed ,
  setSessionMessage
} = sseSession.actions;

export default sseSession.reducer;